<template>
  <div>
    <!--    导航栏-->
    <nav-bar/>

    <!--    主要内容-->
    <div>
      <div class="content-left">
        <el-menu
          :collapse="isCollapse"
          :default-active="defaultActive"
          :router="true"
          :unique-opened="true"
          active-text-color="#07E6F8"
          background-color="transparent"
          class="el-menu-vertical-demo"
          text-color="#07E6F8">
        <span :key="index" v-for="(item,index) in mainContentMenu">

          <el-submenu :index="item.name" v-if="item.children"
                      :class="$route.path.startsWith(item.navUrl) ? 'submenuSelect' : ''">
            <template slot="title">
              <img :src="$route.path.startsWith(item.navUrl) ? item.imgOver : item.imgOut"
                   style="margin-right: 10px;width: 15px;">
              <span :class="$route.path.startsWith(item.navUrl) ? 'text-white' : 'text-lightBlue'" slot="title"
                    v-if="!isCollapse">{{ item.name }}</span>
            </template>
            <el-menu-item-group style="margin-top: 2px">
              <template slot="title"></template>
              <el-menu-item :index="subMenu.navUrl" :key="subMenu.id"
                            v-for="subMenu in item.children">
                <div class="submenu-dot" :class="$route.path.startsWith(subMenu.navUrl) ? 'select' : ''"></div>
                <span style="margin-left: 30px"
                      :class="$route.path.startsWith(subMenu.navUrl) ? 'text-white' : 'text-darkGreen'">{{
                    subMenu.name
                  }}</span>
              </el-menu-item>
            </el-menu-item-group>
          </el-submenu>


          <el-menu-item v-else
                        :class="$route.path.endsWith(item.navUrl) ? 'is-active' : ''" :index="item.navUrl"
                        style="padding-left: 40px;">
            <img :src="$route.path.endsWith(item.navUrl) ? item.imgOver : item.imgOut"
                 style="margin-right: 10px;width: 15px;">
            <span :class="$route.path.endsWith(item.navUrl) ? 'text-white' : 'text-lightBlue'" slot="title"
                  v-if="!isCollapse">{{ item.name }}</span>
          </el-menu-item>
        </span>
        </el-menu>
        <div class="downloadIcon">
          <i class="el-icon-download text-blue pointer"
             @touchstart="openDialog"
             @click="openDialog"
             style="margin: auto;font-size: 1.3rem"></i>
        </div>
      </div>
      <div class="content-right">
        <div class="main">
          <router-view/>
        </div>
      </div>
    </div>


    <dialog-component
      dialog-title="下载列表"
      :closeClick="false"
      :dialogVisible.sync="dialogVisible"
      width="65vw"
      @dialogClose="(data) => this.dialogVisible = data">
      <div slot="content" style="height:70vh;padding: 20px 30px">
        <div class="text-right">
          <el-button size="mini" @touchstart="deleteAllInfo()" @click="deleteAllInfo()">清空</el-button>
        </div>
        <el-table
          :data="tableData"
          :height="'55vh'"
          class="table"
          style="width: 100%;margin-top: 10px;">
          <el-table-column
            align="center"
            label="名称"
            prop="name">
          </el-table-column>
          <el-table-column
            align="center"
            label="时间"
            prop="createTime">
          </el-table-column>
          <el-table-column
            align="center"
            label="状态"
            prop="status">
            <template slot-scope="scope">
              <span v-if="scope.row.status === 0">
                <i class="el-icon-loading"
                   style="font-size: 1.2rem;margin-right: 5px;font-weight: bolder;"></i>
                正在加载中</span>
              <span v-if="scope.row.status === 2">
                <i class="el-icon-close"
                   style="font-size: 1.2rem;margin-right: 5px;font-weight: bolder;color: red;margin-top:3px;"></i>
                导出失败</span>
              <span v-if="scope.row.status === 1" style="color: #58E039">
                <i class="el-icon-check"
                   style="font-size: 1.2rem;margin-right: 5px;font-weight: bolder;">
                </i> 加载完成
              </span>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            label="文件名"
            prop="fileName">
          </el-table-column>
          <el-table-column
            align="center"
            label="操作">
            <template slot-scope="scope">
              <i class="el-icon-download text-blue pointer"
                 @touchstart="exportExcel(scope.row.fileUrl)"
                 @click="exportExcel(scope.row.fileUrl)"
                 v-if="scope.row.status === 1"
                 style="margin-right: 10px;font-size: 1.3rem;">
              </i>
              <i class="el-icon-download text-grey"
                 v-else
                 style="margin-right: 10px;font-size: 1.3rem;cursor: not-allowed">
              </i>

              <i class="el-icon-delete text-red pointer"
                 @touchstart="deleteInfoById(scope.row.id)"
                 @click="deleteInfoById(scope.row.id)"
                 style="font-size: 1.2rem"></i>
            </template>
          </el-table-column>
        </el-table>
        <el-row style="margin-top: 15px;text-align: center;" v-if="tableData.length">
          <el-pagination
            :current-page.sync="form.pageCurrent"
            :page-size="form.pageSize"
            :total="dataTotal"
            @current-change="handleCurrentChange"
            background
            layout="prev, pager, next">
          </el-pagination>
        </el-row>
      </div>
    </dialog-component>
    <iframe frameborder="0" ref="downExcel" style="display:none"></iframe>
  </div>
</template>

<script>
import 'element-ui/lib/theme-chalk/display.css';
import NavBar from "@/views/basic_operations/nav_bar/NavBar1";
import {getResourceList} from "@/network/resource";
import DialogComponent from "@/components/DialogComponent";
import {
  deleteDownloadAllInfo,
  deleteDownloadInfoById,
  getExtDownloadList
} from "../../network/ext-download-record";

export default {
  name: "BasicOperations1",
  components: {NavBar, DialogComponent},
  data() {
    return {
      mainContentMenu: [],
      defaultActive: '/device-space',
      isCollapse: false,
      dialogVisible: false,
      tableData: [],
      form: {
        pageCurrent: 1,
        pageSize: 10,
      },
      dataTotal: 0,
    }
  },
  mounted() {
    this.collapse();
    let currentPath = this.$route.path
    this.getChildMenu(currentPath)
    const array = currentPath.split("/")
    this.defaultActive = array[array.length - 1]
    window.addEventListener('resize', () => this.collapse(), false)
  },
  methods: {
    // 获取子菜单
    getChildMenu(path) {
      getResourceList().then(res => {
        if (res.code === 0) {
          this.mainContentMenu = res.data.resourceTrees
            // 过滤基础引擎菜单
            .filter(item => item.navUrl === 'device-manager')[0].children
            // 过滤子菜单，并跳过/菜单
            .filter(item => item.navUrl !== '/' && path.startsWith(item.navUrl))[0].children
        }
      })
    },
    collapse() {
      this.isCollapse = window.innerWidth < 768;
    },
    handleCurrentChange(val) {
      this.form.pageCurrent = val;
      this.form.pageSize = 10;
      this.getExtDownloadList();
    },
    // 获取可下载列表
    getExtDownloadList() {
      getExtDownloadList(this.form.pageCurrent, this.form.pageSize).then(res => {
        if (res.code === 0) {
          this.tableData = res.data.records;
          this.form.pageCurrent = res.data.current;
          this.form.pageSize = res.data.size;
          this.dataTotal = res.data.total;
        }
      })
    },
    deleteInfoById(id) {
      deleteDownloadInfoById(id).then(res => {
        if (res.code === 0) {
          this.$message.success("删除成功")
          this.form.pageCurrent = 1
          this.getExtDownloadList();
        }
      })
    },
    deleteAllInfo() {
      // 提示读值
      this.$confirm('确定清空吗？', {
        cancelButtonText: '取消',
        confirmButtonText: '确定',
        callback: action => {
          if (action === 'confirm') {
            deleteDownloadAllInfo().then(res => {
              if (res.code === 0) {
                this.$message.success("清空成功")
                this.form.pageCurrent = 1
                this.getExtDownloadList();
              } else {
                this.$message.error(res.message)
              }
            })
          }
        }
      })
    },
    openDialog() {
      this.dialogVisible = true
      this.form.pageCurrent = 1
      this.getExtDownloadList()
    },
    //导出
    exportExcel(fileUrl) {
      let iframe = this.$refs.downExcel;
      const href = window.g.ftpUrl + fileUrl;//接口路径地址，返回数据类型为application/binary，后台控制显示信息，前端仅为下载功能
      console.log(href);
      iframe.src = href
      /* this.isDownload = true;
       if (this.date1) {
         exportEnergy(this.date1).then(res => {
           this.isDownload = false
           if (res.code === 0) {
             let iframe = this.$refs.downExcel;
             const href = window.g.ftpUrl + res.data;//接口路径地址，返回数据类型为application/binary，后台控制显示信息，前端仅为下载功能
             iframe.src = href
           } else {
             this.$message.error(res.message)
           }
         }).catch(err => {
           this.isDownload = false;
           this.$message.error("下载失败");
         });
       } else {
         this.isDownload = false;
         this.$message.warning("请选择日期");
       }*/
    }
  },
  watch: {
    // eslint-disable-next-line no-unused-vars
    '$route.path'(newVal, oldVal) {
      const array = newVal.split("/")
      this.defaultActive = array[array.length - 1]
      this.getChildMenu(newVal)
    }
  }
}
</script>
<style scoped>

.content-left {
  width: 200px;
  height: calc(100vh - 55px);
  float: left;
  padding-right: 2px;
  border-right: 1px solid rgba(41, 155, 255, .2);
  background-color: #05152A;
}

.el-menu-vertical-demo {
  margin-top: 20px;
}

.content-right {
  margin: 10px 10px 0 0;
  width: calc(100% - 220px);
  height: calc(100vh - 80px);;
  float: right;
}

.main {
  height: 100%;
}

.content-left .downloadIcon {
  height: 35px;
  display: flex;
  border-top: 1px solid rgba(41, 155, 255, .2);
}

/*左边菜单图标样式*/
.content-left .el-menu {
  overflow: auto;
  height: calc(100% - 55px);
  border-right: none !important;
}

.content-left .el-menu >>> .el-menu-item.is-active, .content-left .el-menu >>> .el-submenu.is-active.is-opened {
  /*background-color: rgba(41, 155, 255, .6) !important;*/
  background-image: linear-gradient(to right, #050F26, #082640);
  height: 50px;
  line-height: 50px;
}

.content-left .el-menu >>> .el-menu-item, .content-left .el-menu >>> .el-submenu .el-submenu__title {
  height: 50px;
  line-height: 50px;
  padding-left: 30px !important;
}

/*鼠标划入*/
.content-left .el-menu >>> .el-menu-item:hover,
.content-left .el-menu >>> .el-submenu .el-submenu__title:hover {
  background-color: #082640 !important;
}

.el-menu >>> .el-submenu .el-submenu__icon-arrow.el-icon-arrow-down,
.el-menu >>> .el-submenu .el-submenu__icon-arrow.el-icon-arrow-right {
  color: #07E6F8;
  margin-top: -5px;
  margin-right: -10px;
}

/*子菜单点*/
.submenu-dot {
  width: 6px;
  height: 6px;
  display: inline-block;
  border: 1px solid #0098A4;
  border-radius: 50%;
}

.submenu-dot.select {
  border-color: #fff;
  background-color: #fff;
}

/*子菜单*/
.el-menu >>> .el-submenu .el-menu-item {
  min-width: 50px;
  padding-left: 35px !important;
  line-height: 30px;
  height: 35px;
}

/*子菜单选中颜色*/
.el-menu >>> .el-submenu.submenuSelect .el-submenu__title,
.el-menu >>> .el-submenu.submenuSelect .el-menu-item-group {
  background-image: linear-gradient(to right, #050F26, #082640) !important;
}

.el-menu >>> .el-submenu.submenuSelect .el-menu-item-group {
  padding: 8px 0;
}

.el-menu >>> .el-submenu.submenuSelect .el-submenu__icon-arrow.el-icon-arrow-down,
.el-menu >>> .el-submenu.submenuSelect .el-submenu__icon-arrow.el-icon-arrow-right {
  color: #fff;
}

.el-menu >>> .el-menu-item-group .el-menu-item-group__title {
  padding: 0;
}

.el-menu >>> .el-menu-item-group .el-menu-item.is-active {
  background-color: transparent !important;
  color: #fff !important;
}

@media (max-width: 1028px) {
  .content-left {
    width: 150px;
  }

  .content-right {
    width: calc(100% - 170px);
  }

  .content-left .el-menu >>> .el-menu-item, .content-left .el-menu >>> .el-submenu .el-submenu__title {
    padding-left: 15px !important;
  }

  .el-menu >>> .el-submenu .el-menu-item {
    padding-left: 25px !important;
  }
}

@media (max-width: 768px) {
  .content-left {
    width: 80px;
  }

  .content-left .el-menu--collapse {
    width: inherit;
  }

  .content-right {
    width: calc(100% - 90px);
  }

  .content-left .el-menu >>> .el-menu-item, .content-left .el-menu >>> .el-submenu .el-submenu__title {
    padding-left: 22px !important;
  }
}
</style>
